import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum ProductDiscriminatorType {
    SUBSCRIPTION = 'subscription',
    PURCHASE = 'purchase',
    RENTAL = 'rental',
}

export namespace ProductDiscriminatorType {
    type Data = {
        text: string;
        description: string;
    }

    export const Record: Record<ProductDiscriminatorType, Data> = {
        [ProductDiscriminatorType.SUBSCRIPTION]: {
            text: 'Abo',
            description: 'Ein Produkt, das regelmäßig geliefert wird, z.B. Zeitschriften oder Software-Abonnements oder Dienstleistungen.',
        },
        [ProductDiscriminatorType.PURCHASE]: {
            text: 'Kauf',
            description: 'Ein Produkt, das einmalig erworben wird, z.B. Bücher oder Elektronikartikel.',
        },
        [ProductDiscriminatorType.RENTAL]: {
            text: 'Miete / Leasing',
            description: 'Ein Produkt, das für einen bestimmten Zeitraum gemietet oder geleast wird, z.B. Autos oder Instrumente.',
        },
    }

    export const Items = mapRecordToItems(Record);
}
